const UNIT_MAP = {
    kb: {
        factor: 1,
        unitString: "kB"
    },
    mb: {
        factor: 2,
        unitString: "MB"
    },
    gb: {
        factor: 3,
        unitString: "GB"
    }
};

export default function calculateFileSizeString(size, unit) {
    if (!size || !unit) return "";

    const { factor, unitString } = UNIT_MAP[unit];

    return `${Math.round(
        size / (1024 ^ factor)
    ).toString()} ${unitString}`.trim();
}
